module.exports = __webpack_public_path__ + "img/barley-drink.5a9f5106.jpg";